import { Circle } from "@mui/icons-material";
import { AccordionSummary, Typography } from "@mui/material";

import FormatISODateTime from "../../../../global/FormatISODateTime";
import HNSColors from "../../../../ui library/HNSColors";

export default function CustomNotesAccordionSummary({ data }) {
  const createdBy = data?.createdBy?.name;
  const entityType = data?.createdBy?.entity?.entityType;
  const entityTypeName = data?.createdBy?.entity?.entityTypeLabel;
  const createdAt = data?.createdAt;
  const isInternal = data?.internalOnly;

  const bgColor = () => {
    switch (entityType) {
      case 1:
        return HNSColors.secondary[950];
      case 2:
        return HNSColors.warning[600];
      case 3:
        return HNSColors.tertiary[950];
      default:
        return HNSColors.neutrals[700];
    }
  };

  const highlightColor = () => {
    switch (entityType) {
      case 1:
        return HNSColors.secondary[500];
      case 2:
        return HNSColors.warning[500];
      case 3:
        return HNSColors.primary[500];
      default:
        return HNSColors.neutrals[200];
    }
  };

  return (
    <AccordionSummary
      className="px-4 py-2 rounded-2xl"
      sx={{
        backgroundColor: bgColor(),
      }}
    >
      <div className="grid w-full grid-cols-[auto_1fr_auto] items-center justify-between gap-2">
        {/* Icon */}
        <Circle
          sx={{
            height: "24px",
            width: "24px",
            color: highlightColor(),
          }}
        />
        {/* Name and Entity */}
        <div>
          <Typography className="text-base font-semibold" sx={{ color: HNSColors.neutrals[100] }}>
            {createdBy}
            <small className="ml-1 text-xs font-normal" style={{ color: HNSColors.neutrals[400] }}>
              - {entityTypeName}
            </small>
          </Typography>
        </div>
        {/* Date and internal badge */}
        <div className="grid">
          <span className="text-sm" style={{ color: HNSColors.neutrals[400] }}>
            {FormatISODateTime(createdAt, "", " - ")}
          </span>
          {isInternal && (
            <div className="flex justify-end w-full">
              <span
                className="w-fit rounded-lg px-2 py-0.5 text-[10px] font-medium"
                style={{ backgroundColor: highlightColor(), color: HNSColors.neutrals[900] }}
              >
                Internal Note
              </span>
            </div>
          )}
        </div>
      </div>
    </AccordionSummary>
  );
}
